module.exports = __webpack_public_path__ + "static/sample_COZY_PC-8efebc5b614cee312cc2ebde9525c17c.png";